import { Map, Iterable } from 'immutable';
import createMigration from 'redux-persist-migrate';
import jack from 'jack-logs';

// this is the key in the reducer where the app version will be stored.  probably don't move this.

// we need a way to dispatch in here, but that goes against the purpose of it
/*
Essentially, we have all the data we need.  When the app finishes migrating, we're still stuck
on the sign up page.  Need a way to push them to the timeclock page, but if we do that, we need
to make sure that we have the org settings already populated so that we don't get an error due
to the passcode length not being known.  David: See `buffer1` (shiftshift) to find what's a
base state for localStorage to work from.
 */

export function migrationOne(state) {
  jack.dev.log('Performing Migration', {
    state,
    previous: localStorage,
  });
  const newState = state;
  if (!newState.account && !newState.device && localStorage.accessToken) {
    // get feature details
    const features = Object.keys(localStorage)
      .filter(k => /feature_/.test(k))
      .map(k => k.replace('feature_', ''))
      .reduce((f, k) => ({
        ...f,
        [k]: new Map({
          value: localStorage[`feature_${k.toLowerCase()}`] === 'true',
        }),
      }), {});

    return {
      account: new Map({
        accessToken: localStorage.accessToken,
      }),
      device: new Map({
        location: new Map({
          id: parseInt(localStorage.locationId, 10),
          name: localStorage.location,
        }),
        deviceId: localStorage.deviceId,
        nickname: localStorage.nickname,
      }),
      settings: new Map({
        features: new Map(features),
      }),
    };
  }
  if (newState.account instanceof Map
    && newState.account.get('accessToken') === ''
    && localStorage.accessToken
  ) {
    newState.account = newState.account.set('accessToken', localStorage.accessToken);
  }

  return newState;
}

function getVersion(state) {
  jack.dev.log('Getting Version');
  if (!state.persist) {
    return 0;
  }
  if (Iterable.isIterable(state.persist)) {
    return state.persist.get('version');
  }
  if (state.persist.version) {
    return state.persist.version;
  }
  return 0;
}

function setVersion(state, version) {
  jack.dev.log('Setting Version');
  if (state.persist instanceof Map) {
    return state.persist.set('version', version);
  }
  if (state.persist) {
    return {
      ...state,
      persist: {
        ...state.persist,
        version,
      },
    };
  }
  return {
    ...state,
    persist: new Map({
      version,
    }),
  };
}

const migrations = {
  1: migrationOne,
};

export default createMigration(
  migrations,
  getVersion,
  setVersion,
);



// WEBPACK FOOTER //
// ./src/store/migrations.js